import { render, staticRenderFns } from "./repru-auswahl-modal.vue?vue&type=template&id=0b67b42e&scoped=true"
import script from "./repru-auswahl-modal.vue?vue&type=script&lang=js"
export * from "./repru-auswahl-modal.vue?vue&type=script&lang=js"
import style0 from "./repru-auswahl-modal.vue?vue&type=style&index=0&id=0b67b42e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b67b42e",
  null
  
)

export default component.exports